import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ApprovedLendersHub from "@/pages/ApprovedLendersHub";

export const Route = createFileRoute("/approved-lenders/")({
  head: () => seoHead("/approved-lenders"),
  component: ApprovedLendersHub,
});
